import React from 'react';
import { Placeholder } from 'rsuite';
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Line, Tooltip } from 'recharts';
import newsSources from '../utils/newsSources';

export class CountryGraph extends React.Component {
    state = {
        loading: 'loading',
        data: []
    }

    componentDidMount = () => {
        this.retrieveDataFromJson(this.props.country)
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.country !== this.props.country) {
            this.setState({
                loading: 'loading'
            }, () => {
                this.retrieveDataFromJson(this.props.country)
            })

        }
    }

    retrieveDataFromJson = (country) => {
        fetch("https://pomber.github.io/covid19/timeseries.json")
            .then(response => response.json())
            .then(data => {
                let ctry = newsSources['Default'];
                if (newsSources[country] != null) {
                    ctry = newsSources[country]
                }
                if (data[country] == null) {
                    if (ctry.fallbackName !== 'notset') {
                        country = ctry.fallbackName
                    } else {
                        country = null
                    }
                }

                if (country !== null) {
                    this.setState({
                        data: data[country],
                        loading: 'loaded'
                    })
                } else {
                    this.setState({
                        data: [],
                        loading: 'nodata'
                    })
                }
            })
    }

    formatDate = date => {
        const months =["January","February","March",
                      "April","May","June",
                      "July","August","September",
                      "October","November","December"];
        let temp = date.split('-');
        let y = temp[0];
        let m = temp[1] -1;
        let d = temp[2];
        return d + " " + months[m] + " " + y
    }

    render() {
        if (this.state.loading === 'loading') {
            return <Placeholder.Graph style={{ marginTop: 20 }} active />
        } else if (this.state.loading === 'loaded') {
            return (
                <div style={{ width: '100%', height: 200 }}>
                    <ResponsiveContainer>
                        <LineChart
                            data={this.state.data}
                            margin={{
                                top: 20, right: 0, left: 0, bottom: 0,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke={'#3c3f43'} />
                            <XAxis hide dataKey="date" />
                            <YAxis hide />
                            <Tooltip
                                labelFormatter={(label) => this.formatDate(label)}
                                contentStyle={{ borderColor: '#3c3f43', backgroundColor: '#292d33', borderRadius: 6 }}
                                labelStyle={{ fontWeight: 'bold', borderBottom: '1px solid #3c3f43', marginBottom: 5, paddingBottom: 5 }}
                                itemStyle={{ textTransform: 'capitalize', fontSize: 12, lineHeight: '12px' }}
                            />
                            <Line animationBegin={100} type="monotone" dot={false} strokeWidth={3} dataKey="confirmed" stroke="#ffffff" />
                            <Line animationBegin={200} type="monotone" dot={false} strokeWidth={3} dataKey="deaths" stroke="#e84118" />
                            <Line animationBegin={300} type="monotone" dot={false} strokeWidth={3} dataKey="recovered" stroke="#4cd137" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            )
        } else {
            return null
        }
    }
}
